import React, { useEffect, useState } from 'react';
import { AlertTriangle, Crown, X, Clock } from 'lucide-react';
import api from '../../lib/api';

export default function PlanBanner() {
  const [plan, setPlan] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const load = () => api.get('/me/plan').then(({ data }) => setPlan(data)).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => clearInterval(t);
  }, []);

  if (!plan) return null;
  const blocked = plan.ai_blocked;
  const dr = plan.days_remaining;
  const showBanner = blocked || (dr !== null && dr <= 7);

  if (!showBanner) return null;

  // Mandatory upgrade modal — cannot dismiss while ai_blocked
  if (blocked) {
    return (
      <div className="fixed inset-0 z-50 bg-black/60 flex items-center justify-center p-4" data-testid="upgrade-modal">
        <div className="bg-white rounded-2xl max-w-md w-full p-6 shadow-2xl border-2 border-red-300">
          <div className="flex items-start gap-3 mb-3">
            <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0">
              <Crown className="w-5 h-5 text-red-600" />
            </div>
            <div>
              <h3 className="font-display font-bold text-[18px] text-fab-text">
                {plan.plan_status === 'SUSPENDED' ? 'Account Suspended' : 'Your plan has expired'}
              </h3>
              <p className="text-[13px] text-fab-text-secondary mt-1">
                AI replies are paused. Upgrade to resume auto-responding to customer messages.
                You still have full access to your dashboard, data and manual replies.
              </p>
            </div>
          </div>
          <div className="mt-4 rounded-lg bg-fab-elevated p-3 text-[12px]">
            <div className="font-semibold text-fab-text mb-1">How to upgrade</div>
            <ol className="list-decimal ml-4 space-y-0.5 text-fab-text-secondary">
              <li>UPI / Bank transfer to your FABTEXS account manager</li>
              <li>Share the payment screenshot via support</li>
              <li>Plan activated within 4 hours</li>
            </ol>
          </div>
        </div>
      </div>
    );
  }

  if (dismissed) return null;
  const level = plan.banner_level;
  const cls = level === 'danger'
    ? 'bg-red-50 border-red-300 text-red-800'
    : level === 'warning'
    ? 'bg-amber-50 border-amber-300 text-amber-800'
    : 'bg-fab-primary-lighter border-fab-primary-light text-fab-primary';
  const label = plan.is_trial ? 'Free trial' : 'Plan';
  return (
    <div className={`px-4 py-2 border-b text-[13px] flex items-center gap-3 ${cls}`} data-testid="plan-banner">
      {level === 'danger' ? <AlertTriangle className="w-4 h-4 flex-shrink-0" /> : <Clock className="w-4 h-4 flex-shrink-0" />}
      <span className="font-semibold">
        {label} expires in {dr} day{dr === 1 ? '' : 's'}
      </span>
      <span className="text-[12px] opacity-80">
        ({plan.ends_at?.slice(0, 10)})
      </span>
      <span className="text-[12px] opacity-80 ml-auto">Pay via UPI / bank transfer to keep your account active.</span>
      <button
        onClick={() => setDismissed(true)}
        data-testid="plan-banner-dismiss"
        className="ml-2 opacity-60 hover:opacity-100"
      ><X className="w-4 h-4" /></button>
    </div>
  );
}
